import { IXeroPayment } from "@/utilities/types/Payment";
import { Text } from "rizzui";
import { formatCurrencyDefault } from "@/hooks/use-price";
import { GST_PERCENTAGE } from "@/utilities/tax-constants";

interface PaymentAdCreditInformationProps {
  payment: IXeroPayment;
}

export default function PaymentAdCreditInformation({
  payment,
}: PaymentAdCreditInformationProps) {
  // Format date for display
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="rounded-lg border border-gray-100 bg-gray-50 p-4">
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="flex flex-col">
          <Text className="text-sm text-gray-500">Invoice ID</Text>
          <Text className="text-sm font-medium">
            {payment?.xeroInvoiceID || ""}
          </Text>
        </div>
        <div className="flex flex-col">
          <Text className="text-sm text-gray-500">Credit Amount</Text>
          <Text className="text-sm font-medium">
            {payment?.adCreditOrder?.amount || ""}
          </Text>
        </div>

        <div className="flex flex-col">
          <Text className="text-sm text-gray-500">Date</Text>
          <Text className="text-sm font-medium">
            {formatDate(payment?.createdAt)}
          </Text>
        </div>
      </div>

      <div className="flex justify-between my-4">
        <div>
          <Text className="text-gray-600">Description</Text>
          <Text className="font-medium">Ads Credit</Text>
        </div>
        <div>
          <Text className="text-gray-600">Amount</Text>
          <Text className="font-medium">
            {payment?.adCreditOrder?.adCreditData?.amount || ""}
          </Text>
        </div>
        <div>
          <Text className="text-gray-600">GST ({GST_PERCENTAGE}%)</Text>
          <Text className="font-medium">
            {formatCurrencyDefault(
              (Number(payment?.adCreditOrder?.amount || 0) *
                Number(payment?.adCreditOrder?.adCreditData?.price || 0) *
                GST_PERCENTAGE) /
                100 || 0
            )}
          </Text>
        </div>
        <div>
          <Text className="text-gray-600">Price</Text>
          <Text className="font-medium">
            {formatCurrencyDefault(
              Number(payment?.adCreditOrder?.adCreditData?.price || 0)
            )}
          </Text>
        </div>
      </div>

      <div className="flex justify-between my-4">
        <Text className="text-gray-700 font-bold">Total Due:</Text>
        <Text className="font-bold">
          {formatCurrencyDefault(Number(payment?.adCreditOrder?.price || 0))}
        </Text>
      </div>
    </div>
  );
}
